import { render, staticRenderFns } from "./DetailCreditClient.vue?vue&type=template&id=0dcfb92c"
import script from "./DetailCreditClient.vue?vue&type=script&lang=js"
export * from "./DetailCreditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports